<template>
  <div id="History" class="package-wrapper">
    <div class="add-query" v-if="show_buy_package_screen">
      <h2>{{current_package.name}}</h2>
      <b-container fluid class="package-container">
        <b-row>
          <b-col sm=12>
            <b>Doubts:</b>
            <span>{{current_package.credits}}</span>
            <b>Cost:</b>
            <span>{{current_package.cost}}/-</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b>Add on:</b>
            <p>- Tables upto 250</p>
            <p>- Squares upto 1000</p>
            <p>- Cubes upto 250</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm=12>  

            <b>Description</b>
            <p>{{current_package.description}}</p>
            <b-button to="#" class="btn query-btn" variant="primary" @click="buy_package(current_package.id)">Buy for ₹{{current_package.cost}}</b-button>
          </b-col>
        </b-row>

        
        <!-- <b-button to="#" class="query-btn" variant="primary">Know More</b-button> -->
      </b-container>
    </div>
    <b-row id="transaction_success" v-if="transaction_success">
          <b-col>
            <h4>Transaction Successful! You have {{calculated_credits}} Credits available.</h4>
            <p>We have received your payment, and now you can ask your doubts at your ease!</p>
            <p>Here is a summary of your transaction:</p>
            <table>
              <tr>
                <td>Payment Id:</td>
                <td>{{transaction_summary.payment_id}}</td>
              </tr>
              <tr>
                <td>Package Name:</td>
                <td>{{current_package.name}}</td>
              </tr>
              <tr>
                <td>Credits:</td>
                <td>{{current_package.credits}}</td>
              </tr>
            </table><br>
            <p>Thanks a lot, we are awaiting your doubts, Go ahead!</p>
            <b-button class="btn btn-blue" to="/dashboard/add-doubt">Ask a Doubt</b-button>

          </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "PackageView",
  data() {
    return {
      msg: "Welcome to QdsPro",
      form: {
        qtitle: "",
        selected: null,
        doubt: ""
      },
      show_buy_package_screen:true, //show buy_package screen by default
      selected_package:{},
      buy_package_id:'',
      transaction_success:false, // show transaction success screen
      transaction_summary: {
        payment_id:'',
        transaction:''
      }
    };
  },
  mounted() {
    this.$store.dispatch("fetch_packages");
  },
  methods: {
    onSubmit() {
      console.log("submitted");
      this.$router.push("/dashboard");
    },
    async capture_payment(razorpay_response) {
      var razorpay_payment_id = razorpay_response.razorpay_payment_id;
      
      try {
        this.$store.commit('setLoader',true);
        var result = await this.$store.dispatch('capture_payment',{razorpay_payment_id:razorpay_payment_id,package_id:this.buy_package_id});

        this.transaction_summary = result.data.data;

        var result2 = await this.$store.dispatch('fetch_me');

        this.show_buy_package_screen = false;
        this.transaction_success = true;

        this.$store.commit('setLoader',false);


      } catch(ex) {
        this.$toasted.show("We had a problem processing your transaction, please try again!");
      }
    },
    buy_package(package_id) {
      this.buy_package_id = package_id;
      var rzp_options = {
          key: "rzp_live_oZ13b2cVYTIpGt",
          amount: this.current_package.cost * 100,
          name: "QdsPro",
          description: "Buy Package " + this.current_package.name,
          handler: this.capture_payment,
          theme: {
              color: "#77bf43"
          }
      };
      
      var rzp1 = new Razorpay(rzp_options);
      rzp1.open();

    }
  },
  computed: {
    packages: function() {
      return this.$store.getters.get_packages;
    },
    user_info: function() {
      return this.$store.getters.user;
    },
    current_package: function() {
      var package_id = this.$route.params.id;

      //return this.$route.params.id;
      return _.find(this.packages, { id: Number(package_id) });
    },
    calculated_credits: function() {
      if(this.user_info.credits.credit != null) {
        if(this.user_info.credits.debit != null) {
          return parseFloat(this.user_info.credits.credit) - parseFloat(this.user_info.credits.debit)
        } else return parseFloat(this.user_info.credits.credit);
      } else {
        return 0;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add-query h2 {
  color: #262e3b;
  text-transform: uppercase;
  font-weight: bold;
  padding: 20px 0;
  border-bottom: 1px solid #e5e5e5;
  
  margin: 0 auto;
}
.package-container {
  
  margin: 20px auto 0;
}
.package-head {
  border-bottom: 1px solid #efefef;
  color: #aacf37;
  font-weight: bold;
}
.package-item a {
  border-radius: 10px;
}
.package-item p {
  margin: 0;
}
.package-item .row,
.package-item a {
  margin-top: 20px;
  margin-bottom: 20px;
}
.package-container .col-lg-4 {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/PackageView.vue